module.exports = __webpack_public_path__ + "cd00d6ced1d5246a86a8fa6be9505d0c.mp4";